import React from "react";

import AppIcon from "../app-icon";
import Tooltip from "../tooltip";

import "./help-button.scss";

export const HELP_CENTER_URL = "https://help.tripgrid.com";

interface Props {
  /**
   * Click handler for the CTA. Defaults to opening the help center in a new
   * tab, which mirrors the existing sidebar-footer help affordance. When the
   * support modal lands this is the single swap point: pass the modal's open
   * handler and the button stops navigating away.
   */
  onClick?: () => void;
}

/**
 * `HelpButton` renders a fixed-position help affordance in the bottom-right
 * corner of the screen for every authenticated user. Ported from the
 * `BCDHelpButton` in tripgrid-web (booking.tripgrid.com), minus the `isBCD`
 * feature gate and the BCD Smartsheet intake form it pointed at.
 */
const HelpButton = (props: Props) => {
  const { onClick } = props;

  const handleClick = () => {
    if (onClick) {
      onClick();
      return;
    }

    window.open(HELP_CENTER_URL, "_blank", "noreferrer");
  };

  return (
    <Tooltip text="Help">
      <button
        aria-label="Help"
        className="help-button"
        onClick={handleClick}
        type="button"
      >
        <AppIcon color="white" size="medium" type="help-center" />
      </button>
    </Tooltip>
  );
};

export default HelpButton;
